import { computed, toValue } from 'vue';

import { useRoute } from 'vue-router';

import { FALLBACK_PAGE_GUIDE, findPageGuide } from '@/config/pageGuides.js';
import { useEnvironmentStore } from '@/stores/environment';

// The page guide (src/config/pageGuides.js) for the current route.
//   guide    – the authored entry, or the generic fallback
//   hasGuide – true only for an authored entry (gates the header "About this page")
//
// `fallbackRequires` (value, ref or getter: 'ads' | 'sp' | null) is what the host knows
// about the page's data source — OlapPage derives it from the dataset config. It only
// fills the gap on a route without an entry; an authored entry's own `requires` wins.
export function usePageGuide(fallbackRequires = null) {
  const route = useRoute();
  const environmentStore = useEnvironmentStore();

  const authored = computed(() => findPageGuide(route, { isDevelopment: environmentStore.isDevelopment }));
  const hasGuide = computed(() => !!authored.value);
  const guide = computed(() => {
    if (authored.value) return authored.value;
    const requires = toValue(fallbackRequires);
    return requires ? { ...FALLBACK_PAGE_GUIDE, requires } : FALLBACK_PAGE_GUIDE;
  });

  return { guide, hasGuide };
}
